import { createSelector } from 'reselect';
import { ALERT_DIALOG } from './constants';

const selectAlertDialog = state => state?.[ALERT_DIALOG];

export const selectAlert = createSelector(selectAlertDialog, state => state ? state.get('alert') : {});